import React from 'react';
import { Box, Typography } from '@mui/material';
import logo from '../../images/MEWIN_new_logo.svg';
import { createPortal } from 'react-dom';

/**
 * Wraps game content. Jab showLoader true ho, content blur ho jata
 * hai aur center me logo overlay dikhta hai.
 * Mobile-first responsive design.
 */
const RoundLoader = ({ showLoader, children }) => {
    return (
        <Box sx={{ position: 'relative', width: '100%' }}>

            {/* Actual game content - blurred when loader active */}
            <Box
                sx={{
                    filter: showLoader ? 'blur(4px)' : 'none',
                    pointerEvents: showLoader ? 'none' : 'auto',
                    userSelect: showLoader ? 'none' : 'auto',
                    transition: 'filter 0.2s ease',
                }}
            >
                {children}
            </Box>

            {/* Center logo overlay */}
            {showLoader && createPortal (
         <Box
    sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100dvw',
        height: '100dvh',
        
        '@supports not (height: 100dvh)': {
            height: '100vh',
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(0, 0, 0)',
        zIndex: 1300,
    }}
>
                    <Box
                        component="img"
                        src={logo}
                        alt="loading"
                        sx={{
                            width: { xs: '110px', sm: '150px', md: '200px' },
                            animation: 'roundLoaderPulse 1.2s ease-in-out infinite',
                        }}
                    />

                    {/* Progress bar */}
                    <Box
                        sx={{
                            width: { xs: '140px', sm: '180px' },
                            height: '4px',
                            borderRadius: '4px',
                            background: 'rgb(49, 49, 49)',
                            overflow: 'hidden',
                            mt: 2,
                        }}
                    >
                        <Box
                            sx={{
                                height: '100%',
                                borderRadius: '4px',
                                background: '#ffffff',
                              animation: 'roundLoaderProgress 3s linear forwards',
                            }}
                        />
                    </Box>

                    <Typography
                        sx={{
                            color: '#d6b72e',
                            fontSize: { xs: '12px', sm: '14px' },
                            mt: 1.5,
                            letterSpacing: '1px',
                            opacity: 0.8,
                        }}
                    />
                 
              
                </Box>,
                 document.body 
            )}

            {/* Pulse animation for logo */}
            <style>
                {`
                    // @keyframes roundLoaderPulse {
                    //     0% { transform: scale(1); opacity: 0.7; }
                    //     50% { transform: scale(1.08); opacity: 1; }
                    //     100% { transform: scale(1); opacity: 0.7; }
                    // }
                    @keyframes roundLoaderProgress {
                        0% { width: 0%; }
                        100% { width: 100%; }
                    }
                `}
            </style>
        </Box>
    );
};

export default RoundLoader;